import React, { useState, useEffect, useRef } from 'react';
import { supabase } from './supabase';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

// FIX: disuasivo contra screenshots que se manden a clientes fuera de
// control — grande y notoria a propósito, para que a nadie le convenga
// mandar un screenshot de la pantalla y prefieran descargar el PDF limpio.
// Nunca se incluye en el PDF (ver comentario donde se usa en el JSX
// principal). Sin contacto asignado (Descargar/Compartir bloqueados)
// muestra un aviso distinto y en rojo — la cotización todavía no es
// válida porque el cliente no está registrado. En cuanto se asigna
// contacto vuelve a la marca normal (agente + fecha).
function MarcaDeAgua({ lineas, urgente }) {
  const color = urgente ? '#A32D2D' : '#1a1a2e';
  return (
    <div style={{ position: 'absolute', inset: 0, overflow: 'hidden', pointerEvents: 'none', zIndex: 5 }}>
      <div style={{ position: 'absolute', inset: '-30%', display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', transform: 'rotate(-30deg)', opacity: urgente ? 0.22 : 0.16 }}>
        {Array.from({ length: 14 }).map((_, i) => (
          <div key={i} style={{ textAlign: 'center', padding: '48px 8px', color }}>
            {lineas.map((linea, j) => (
              <div key={j} style={{ fontSize: j === 0 ? '17px' : '15px', fontWeight: j === 0 ? 600 : 500, whiteSpace: 'nowrap', marginTop: j > 0 ? '2px' : 0 }}>{linea}</div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}

export default function Cotizador({ unidad, unidades: unidadesMultiple, desarrollo, onClose }) {
  const [planes, setPlanes] = useState([]);
  const [contactos, setContactos] = useState([]);
  const [buscarContacto, setBuscarContacto] = useState('');
  const [showContactos, setShowContactos] = useState(false);
  const [contactoSeleccionado, setContactoSeleccionado] = useState(null);
  const [asesor, setAsesor] = useState({ nombre: '', celular: '', email: '' });
  const [generando, setGenerando] = useState(false);
  const [compartiendo, setCompartiendo] = useState(false);
  const [mostrarPrecioM2, setMostrarPrecioM2] = useState(false);
  // FIX: datos bancarios específicos de la torre/etapa de la unidad, si
  // existen — se usan en vez del dato general del desarrollo.
  const [datosBancariosTorre, setDatosBancariosTorre] = useState(null);
  const [promos, setPromos] = useState([]);
  const [usadasPromos, setUsadasPromos] = useState({});
  const cotizacionRef = useRef();
  const contenedorRef = useRef();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

  const listaUnidades = unidadesMultiple?.length > 0 ? unidadesMultiple : (unidad ? [unidad] : []);
  const esComparacion = listaUnidades.length > 1;

  useEffect(() => { cargarPlanes(); cargarPromos(); cargarAsesor(); cargarContactos(); cargarDatosBancariosTorre(); }, []);

  // FIX: registra en `cotizaciones_log` cada unidad de la cotización (una
  // fila por unidad, incluso en comparación) — pero solo cuenta como
  // cotización real cuando hay un contacto asignado Y se completó una
  // acción de entrega (descargar PDF o compartir/reenviar). Antes se
  // registraba con solo ABRIR el cotizador, lo que inflaba las métricas
  // de Tendencias con unidades que un agente solo estaba explorando.
  const registrarLog = async () => {
    if (!contactoSeleccionado) return;
    try {
      const { data: { user } } = await supabase.auth.getUser();
      let agenteNombre = '';
      const agenteCorreo = user?.email || '';
      if (user) {
        const { data } = await supabase.from('agentes').select('nombre, apellidos').eq('correo', user.email).single();
        if (data) agenteNombre = `${data.nombre || ''} ${data.apellidos || ''}`.trim();
      }
      const filas = listaUnidades.map(u => ({
        agente_correo: agenteCorreo,
        agente_nombre: agenteNombre,
        desarrollo_id: desarrollo.id,
        desarrollo_nombre: desarrollo.nombre,
        unidad_id: u.id,
        unidad_numero: u.numero,
        tipologia: u.tipologia || null,
        nivel: u.nivel || null,
        precio_lista: u.precio_lista || null,
        contacto_id: contactoSeleccionado.id,
        contacto_nombre: `${contactoSeleccionado.nombres} ${contactoSeleccionado.apellidos}`.trim(),
      }));
      if (filas.length > 0) await supabase.from('cotizaciones_log').insert(filas);
    } catch (err) {
      // el log nunca debe bloquear la cotización si falla
    }
    await crearNegocioSiNoExiste();
  };

  // FIX: cotizar a un cliente con contacto asignado (mismo disparador que
  // registrarLog: descargar o compartir/reenviar el PDF) arranca su
  // negocio automáticamente en "Cotización", con la unidad y el
  // desarrollo cotizados — si ya tiene un negocio en ese desarrollo (en
  // cualquier etapa), no se crea otro ni se le toca nada.
  const crearNegocioSiNoExiste = async () => {
    if (!contactoSeleccionado) return;
    try {
      const { data: existentes } = await supabase.from('negocios').select('id')
        .eq('contacto_id', contactoSeleccionado.id).eq('desarrollo', desarrollo.nombre).limit(1);
      if (existentes && existentes.length > 0) return;
      const { data: { user } } = await supabase.auth.getUser();
      let agenteNombre = '';
      const agenteCorreo = user?.email || '';
      if (user) {
        const { data } = await supabase.from('agentes').select('nombre, apellidos').eq('correo', user.email).single();
        if (data) agenteNombre = `${data.nombre || ''} ${data.apellidos || ''}`.trim();
      }
      const u = listaUnidades[0];
      const ahoraIso = new Date().toISOString();
      await supabase.from('negocios').insert([{
        nombre: `${contactoSeleccionado.nombres} ${contactoSeleccionado.apellidos}`.trim(),
        contacto_id: contactoSeleccionado.id,
        desarrollo: desarrollo.nombre,
        unidad: u?.numero || null,
        unidad_id: u?.id || null,
        valor: u?.precio_lista || 0,
        // Showroom ya llegó al punto de venta: el negocio empieza en Cita.
        etapa: contactoSeleccionado.fuente_medio === 'Showroom' ? 'Cita' : 'Cotización',
        ...(contactoSeleccionado.fuente_medio === 'Showroom'
          ? { inicio_directo_cita: true, cita_en: ahoraIso }
          : { cotizacion_en: ahoraIso }),
        asesor_ventas: agenteNombre,
        asesor_correo: agenteCorreo,
        creado_por: agenteCorreo,
        ultima_actividad: ahoraIso,
        vigencia_activa: true,
      }]);
    } catch (err) {
      // igual que el log, esto nunca debe bloquear la cotización si falla
    }
  };

  const cargarPromos = async () => {
    const { data } = await supabase.from('promociones_desarrollo').select('*').eq('desarrollo_id', desarrollo.id);
    setPromos(data || []);
    // Unidades ya usadas por cada promoción con tope ("hasta agotar existencias").
    const idsConTope = (data || []).filter(p => p.tope_unidades != null).map(p => p.id);
    if (idsConTope.length > 0) {
      const { data: uso } = await supabase.rpc('promociones_usadas', { ids: idsConTope });
      setUsadasPromos(Object.fromEntries((uso || []).map(u => [u.promocion_id, Number(u.usadas)])));
    }
  };

  // Promociones vigentes de la torre/etapa (o del desarrollo si no tiene etapas): activas, dentro de su
  // vigencia y, si están limitadas a ciertos prototipos, que incluyan el de la unidad.
  const promosDe = (estructura, tipologia, numero) => {
    const hoy = new Date().toLocaleDateString('en-CA');
    return promos.filter(p => {
      if (p.estructura !== (desarrollo.tiene_etapas ? (estructura || '') : '')) return false;
      if (!p.activa) return false;
      if (p.vigencia_desde && p.vigencia_desde > hoy) return false;
      if (p.vigencia_hasta && p.vigencia_hasta < hoy) return false;
      if (p.tipologias?.length && !p.tipologias.includes((tipologia || '').trim())) return false;
      if (p.unidades?.length && !p.unidades.includes(String(numero || '').trim())) return false;
      if (p.tope_unidades != null && (usadasPromos[p.id] || 0) >= p.tope_unidades) return false;
      return true;
    });
  };
  const fmtFechaPromo = (iso) => iso ? iso.split('-').reverse().join('/') : '';

  const cargarPlanes = async () => {
    // FIX: si el desarrollo tiene torres/etapas, solo trae los planes
    // asociados a la torre/etapa de la unidad que se está cotizando
    let query = supabase.from('planes_pago').select('*').eq('desarrollo_id', desarrollo.id).eq('activo', true);
    const u = listaUnidades[0];
    if (desarrollo.tiene_etapas && u?.estructura) {
      query = query.eq('estructura', u.estructura);
    }
    const { data } = await query.order('created_at');
    setPlanes(data || []);
  };

  // FIX: busca en desarrollo_estructuras si la torre/etapa de la unidad
  // tiene su propia cuenta bancaria configurada. Solo aplica en
  // cotización individual (no en comparación, porque ahí puede haber
  // unidades de varias torres distintas a la vez).
  const cargarDatosBancariosTorre = async () => {
    const u = listaUnidades[0];
    if (!desarrollo.tiene_etapas || !u?.estructura || listaUnidades.length > 1) { setDatosBancariosTorre(null); return; }
    const { data } = await supabase.from('desarrollo_estructuras')
      .select('datos_bancarios').eq('desarrollo_id', desarrollo.id).eq('nombre', u.estructura).limit(1);
    const valor = data && data.length > 0 ? data[0].datos_bancarios : null;
    setDatosBancariosTorre(valor && valor.trim() ? valor : null);
  };

  // FIX: antes traía TODOS los contactos sin importar el rol — un Agente
  // podía ver (y elegir) contactos de otros asesores al cotizar, lo cual
  // es una fuga de información de clientes. Ahora la consulta misma trae
  // solo lo que corresponde: Agente/Desarrollador → los suyos; Gerente →
  // los de su equipo/proyectos a cargo; Super Admin/Admin/Sub Admin → todos.
  const cargarContactos = async () => {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) { setContactos([]); return; }
    const { data: miAgenteData } = await supabase.from('agentes')
      .select('rol, nombre, apellidos, correo, desarrollos_cargo, agentes_cargo')
      .eq('correo', user.email).single();
    if (!miAgenteData) { setContactos([]); return; }

    const rol = miAgenteData.rol;
    const correo = miAgenteData.correo;
    const nombreCompleto = `${miAgenteData.nombre || ''} ${miAgenteData.apellidos || ''}`.trim();
    const cargo = miAgenteData.desarrollos_cargo || [];
    const ROLES_VER_TODOS = ['Super Admin', 'Admin', 'Sub Admin'];

    let query = supabase.from('contactos').select('id, nombres, apellidos, correo, telefono, fuente_medio').order('nombres');

    if (ROLES_VER_TODOS.includes(rol)) {
      // sin filtro — ve todos
    } else if (rol === 'Gerente Externo') {
      const agentesCargoCorreos = miAgenteData.agentes_cargo || [];
      const { data: equipo } = agentesCargoCorreos.length > 0
        ? await supabase.from('agentes').select('nombre, apellidos').in('correo', agentesCargoCorreos)
        : { data: [] };
      const nombresEquipo = (equipo || []).map(a => `${a.nombre} ${a.apellidos}`.trim());
      const nombresFiltro = [nombreCompleto, ...nombresEquipo].filter(Boolean);
      query = nombresFiltro.length > 0
        ? query.or(`creado_por.eq.${correo},asesor_ventas.in.(${nombresFiltro.map(n => `"${n}"`).join(',')})`)
        : query.eq('creado_por', correo);
      if (cargo.length > 0) query = query.in('desarrollo', cargo);
    } else if (rol === 'Gerente Editor' || rol === 'Gerente Operador') {
      query = cargo.length > 0
        ? query.or(`creado_por.eq.${correo},desarrollo.in.(${cargo.map(d => `"${d}"`).join(',')})`)
        : query.eq('creado_por', correo);
    } else {
      // FIX: antes también incluía creado_por, así que un agente seguía
      // viendo (y podía cotizarle a) un contacto que ya se había
      // reasignado a alguien más. Ahora solo ve lo que asesor_ventas dice
      // que es suyo ahorita — mismo criterio que contactos.js.
      query = query.eq('asesor_ventas', nombreCompleto);
    }

    const { data } = await query;
    setContactos(data || []);
  };

  const cargarAsesor = async () => {
    const { data: { user } } = await supabase.auth.getUser();
    if (user) {
      const { data } = await supabase.from('agentes').select('nombre, apellidos, telefono, correo').eq('correo', user.email).single();
      if (data) {
        setAsesor({ nombre: `${data.nombre || ''} ${data.apellidos || ''}`.trim(), celular: data.telefono || '', email: data.correo || user.email });
      } else {
        setAsesor(a => ({ ...a, email: user.email }));
      }
    }
  };

  // FIX: si la unidad tiene su propia fecha de entrega (distinta a la
  // general del desarrollo/torre), las mensualidades se calculan con los
  // meses reales que le quedan a ESA unidad en vez del meses_plan fijo
  // del plan. Sin fecha propia, no cambia nada (se sigue usando meses_plan).
  const mesesEfectivosEntrega = (unidad) => {
    if (!unidad?.fecha_entrega) return null;
    const hoy = new Date();
    const entrega = new Date(unidad.fecha_entrega + 'T00:00:00');
    const meses = (entrega.getFullYear() - hoy.getFullYear()) * 12 + (entrega.getMonth() - hoy.getMonth());
    return Math.max(1, meses);
  };

  const calcularPlan = (plan, precio, mesesOverride) => {
    const precioConPreventa = precio * (1 - plan.descuento_preventa / 100);
    const precioConDescuento = precioConPreventa * (1 - plan.descuento_plan / 100);
    const enganche = precioConDescuento * plan.enganche / 100;
    const duranteObra = precioConDescuento * plan.durante_obra / 100;
    const restoPorc = 100 - plan.enganche - plan.durante_obra;
    const resto = precioConDescuento * restoPorc / 100;
    const mesesUsados = mesesOverride > 0 ? mesesOverride : plan.meses_plan;
    const mensualidad = mesesUsados > 0 ? duranteObra / mesesUsados : 0;
    const ahorro = precio - precioConDescuento;
    return { precioConDescuento, enganche, duranteObra, mensualidad, ahorro, entrega: resto, restoPorc, mesesUsados };
  };

  const generarPDFBlob = async () => {
    setShowContactos(false);
    const elemento = cotizacionRef.current;
    const contenedor = contenedorRef.current;

    // Quitar temporalmente la escala para capturar en tamaño real
    const transformOriginal = contenedor ? contenedor.style.transform : '';
    const widthOriginal = contenedor ? contenedor.style.width : '';
    const heightOriginal = contenedor ? contenedor.style.height : '';

    if (contenedor) {
      contenedor.style.transform = 'none';
      contenedor.style.width = 'auto';
      contenedor.style.height = 'auto';
    }

    // Pequeña pausa para que el DOM se actualice
    await new Promise(r => setTimeout(r, 100));

    const canvas = await html2canvas(elemento, { scale: 2, useCORS: true, backgroundColor: '#ffffff' });
    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF(esComparacion ? 'l' : 'p', 'mm', 'letter');
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();
    pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);

    // Restaurar escala
    if (contenedor) {
      contenedor.style.transform = transformOriginal;
      contenedor.style.width = widthOriginal;
      contenedor.style.height = heightOriginal;
    }

    const nombreArchivo = esComparacion
      ? `Comparacion_${desarrollo.nombre}_${listaUnidades.map(u => u.numero).join('-')}.pdf`
      : `Cotizacion_${desarrollo.nombre}_${listaUnidades[0].numero}.pdf`;

    return { blob: pdf.output('blob'), nombre: nombreArchivo };
  };

  const handleDescargar = async () => {
    setGenerando(true);
    const { blob, nombre } = await generarPDFBlob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = nombre;
    a.click();
    URL.revokeObjectURL(url);
    registrarLog();
    setGenerando(false);
  };

  const handleCompartir = async () => {
    setCompartiendo(true);
    const { blob, nombre } = await generarPDFBlob();
    const file = new File([blob], nombre, { type: 'application/pdf' });
    // FIX: solo cuenta como "reenviada" si el share realmente se completó
    // o si cayó al fallback de descarga manual — no si el usuario canceló
    // el share sheet (AbortError).
    let completado = false;

    if (navigator.share && navigator.canShare && navigator.canShare({ files: [file] })) {
      try {
        await navigator.share({ files: [file], title: nombre });
        completado = true;
      } catch (err) {
        if (err.name !== 'AbortError') {
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = nombre;
          a.click();
          URL.revokeObjectURL(url);
          completado = true;
        }
      }
    } else {
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = nombre;
      a.click();
      URL.revokeObjectURL(url);
      completado = true;
    }
    if (completado) registrarLog();
    setCompartiendo(false);
  };

  const contactosFiltrados = contactos.filter(c =>
    !buscarContacto || `${c.nombres} ${c.apellidos}`.toLowerCase().includes(buscarContacto.toLowerCase()) ||
    c.correo?.toLowerCase().includes(buscarContacto.toLowerCase())
  );

  const fmt = (n) => `$${Number(n).toLocaleString('es-MX', { maximumFractionDigits: 0 })}`;
  const fechaActual = new Date().toLocaleString('es-MX', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });

  const fila = (label, valor) => (
    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '10px', marginBottom: '3px' }}>
      <span style={{ color: '#555' }}>{label}</span>
      <span style={{ fontWeight: '600' }}>{valor}</span>
    </div>
  );

  const anchoDoc = esComparacion ? 1056 : 816;
  const escala = isMobile ? (window.innerWidth - 32) / anchoDoc : 1;

  const renderComparacion = () => (
    <div ref={cotizacionRef} style={{
      background: '#fff', width: '1056px', minHeight: '816px', padding: '32px',
      boxSizing: 'border-box', fontFamily: 'Arial, sans-serif'
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', paddingBottom: '16px', borderBottom: '2px solid #1a1a2e' }}>
        <div>
          {desarrollo.logo_url
            ? <img src={desarrollo.logo_url} alt={desarrollo.nombre} style={{ maxHeight: '60px', maxWidth: '160px', objectFit: 'contain' }} />
            : <div style={{ fontSize: '22px', fontWeight: '900', color: '#1a1a2e' }}>{desarrollo.nombre}</div>}
        </div>
        <div style={{ textAlign: 'right' }}>
          <div style={{ fontSize: '14px', fontWeight: '700', color: '#1a1a2e' }}>Comparación de unidades</div>
          {contactoSeleccionado && (
            <div style={{ fontSize: '11px', color: '#555', marginTop: '4px' }}>
              Para: {contactoSeleccionado.nombres} {contactoSeleccionado.apellidos}
            </div>
          )}
          <div style={{ fontSize: '10px', color: '#888', marginTop: '2px' }}>{fechaActual}</div>
        </div>
      </div>
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '11px', marginBottom: '20px' }}>
        <thead>
          <tr style={{ background: '#1a1a2e', color: '#fff' }}>
            <th style={{ padding: '8px 12px', textAlign: 'left', fontWeight: '600' }}>Característica</th>
            {listaUnidades.map(u => (
              <th key={u.id} style={{ padding: '8px 12px', textAlign: 'center', fontWeight: '600' }}>Unidad {u.numero}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {[
            ['Tipología', u => u.tipologia],
            ['Nivel', u => u.nivel],
            ['m² Interior', u => `${u.m2_interior} m²`],
            ['m² Terraza', u => `${u.m2_terraza} m²`],
            ['m² Total', u => `${u.m2_total} m²`],
            ['Recámaras', u => u.recamaras],
            ['Baños', u => u.banos],
            ['Estacionamiento', u => u.estacionamiento],
            ['Precio Lista', u => fmt(u.precio_lista)],
            ['Precio por m²', u => fmt(u.precio_m2)],
            ['Estatus', u => u.estatus],
          ].filter(([label]) => label !== 'm² Terraza' || listaUnidades.some(u => Number(u.m2_terraza) > 0)).map(([label, getter], i) => (
            <tr key={label} style={{ background: i % 2 === 0 ? '#f9f9f9' : '#fff' }}>
              <td style={{ padding: '6px 12px', fontWeight: '500', color: '#333' }}>{label}</td>
              {listaUnidades.map(u => (
                <td key={u.id} style={{ padding: '6px 12px', textAlign: 'center', color: '#333' }}>{getter(u) || '—'}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      {(() => {
        // Promociones que aplican a al menos una de las unidades comparadas (sin repetir).
        const vistas = new Map();
        listaUnidades.forEach(u => promosDe(u.estructura, u.tipologia, u.numero).forEach(p => { if (!vistas.has(p.id)) vistas.set(p.id, p); }));
        const lista = [...vistas.values()];
        if (lista.length === 0) return null;
        return (
          <div style={{ marginBottom: '16px', padding: '8px 12px', background: '#FFF8E1', border: '1px solid #F0D98A', borderRadius: '4px' }}>
            <div style={{ fontSize: '11px', fontWeight: '700', color: '#333', marginBottom: '4px' }}>{lista.length > 1 ? 'PROMOCIONES:' : 'PROMOCIÓN:'}</div>
            {lista.map(p => (
              <div key={p.id} style={{ marginBottom: '4px' }}>
                <div style={{ fontSize: '11px', color: '#444', whiteSpace: 'pre-line', lineHeight: '1.5' }}>
                  {p.texto}{p.tipologias?.length ? ` (prototipo ${p.tipologias.join(', ')})` : ''}
                </div>
                {p.vigencia_hasta && <div style={{ fontSize: '10px', color: '#888' }}>Vigente hasta el {fmtFechaPromo(p.vigencia_hasta)}</div>}
              </div>
            ))}
            <div style={{ fontSize: '10px', color: '#666', marginTop: '4px', fontStyle: 'italic' }}>*Consulta términos y condiciones</div>
          </div>
        );
      })()}
      {planes.length > 0 && (
        <div>
          <div style={{ fontSize: '13px', fontWeight: '700', color: '#1a1a2e', marginBottom: '12px' }}>Opciones de pago por unidad</div>
          <div style={{ display: 'grid', gridTemplateColumns: `repeat(${listaUnidades.length}, 1fr)`, gap: '16px' }}>
            {listaUnidades.map(u => (
              <div key={u.id}>
                <div style={{ fontSize: '12px', fontWeight: '700', color: '#1a1a2e', marginBottom: '8px', textAlign: 'center', background: '#f0f0f0', padding: '6px', borderRadius: '4px' }}>
                  Unidad {u.numero} — {fmt(u.precio_lista)}
                </div>
                {planes.map(plan => {
                  const calc = calcularPlan(plan, u.precio_lista || 0, mesesEfectivosEntrega(u));
                  return (
                    <div key={plan.id} style={{ border: '1px solid #ddd', borderRadius: '6px', marginBottom: '8px', overflow: 'hidden' }}>
                      <div style={{ background: '#1a1a2e', color: '#fff', padding: '5px 8px', fontSize: '10px', fontWeight: '700', textAlign: 'center' }}>
                        {plan.nombre.toUpperCase()}
                      </div>
                      <div style={{ padding: '8px' }}>
                        {fila('Precio con descuento:', fmt(calc.precioConDescuento))}
                        {mostrarPrecioM2 && Number(u.m2_total) > 0 && fila('Precio por m²:', fmt(calc.precioConDescuento / Number(u.m2_total)))}
                        {fila('Ahorro:', fmt(calc.ahorro))}
                        {fila(`Enganche (${plan.enganche}%):`, fmt(calc.enganche))}
                        {fila(`Durante obra (${plan.durante_obra}%):`, fmt(calc.duranteObra))}
                        {calc.mesesUsados > 0 && fila(`${calc.mesesUsados} mensualidades${calc.mesesUsados !== plan.meses_plan ? ' (ajustadas)' : ''}:`, fmt(calc.mensualidad))}
                        {fila(`A la entrega (${calc.restoPorc}%):`, fmt(calc.entrega))}
                      </div>
                    </div>
                  );
                })}
              </div>
            ))}
          </div>
        </div>
      )}
      <div style={{ marginTop: '16px', paddingTop: '12px', borderTop: '1px solid #ddd', display: 'flex', justifyContent: 'space-between', fontSize: '9px', color: '#888' }}>
        <div><strong>Asesor:</strong> {asesor.nombre} | {asesor.celular} | {asesor.email}</div>
        <div style={{ maxWidth: '400px', textAlign: 'right', lineHeight: '1.4' }}>
          Todos los precios y áreas son estimados. Válido por 24 horas a partir de: {fechaActual}
        </div>
      </div>
    </div>
  );

  const renderIndividual = () => {
    const u = listaUnidades[0];
    const precio = u?.precio_lista || 0;
    const detalles = u?.detalles ? u.detalles.split('\n').filter(d => d.trim()) : [];
    // FIX: prioriza la cuenta bancaria de la torre/etapa de la unidad;
    // si no hay una configurada específicamente, cae al dato general
    // del desarrollo (comportamiento igual al de antes).
    const datosBancariosMostrar = datosBancariosTorre || desarrollo.datos_bancarios;
    return (
      <div ref={cotizacionRef} style={{
        background: '#fff', width: '816px', height: '1056px', padding: '36px',
        boxSizing: 'border-box', display: 'grid', gridTemplateColumns: '1fr 1fr',
        gap: '28px', fontFamily: 'Arial, sans-serif', position: 'relative'
      }}>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div style={{ textAlign: 'center', marginBottom: '20px' }}>
            {desarrollo.logo_url
              ? <img src={desarrollo.logo_url} alt={desarrollo.nombre} style={{ maxHeight: '80px', maxWidth: '180px', objectFit: 'contain' }} />
              : <div style={{ fontSize: '24px', fontWeight: '900', color: '#1a1a2e', letterSpacing: '3px' }}>{desarrollo.nombre}</div>}
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '12px', paddingBottom: '12px', borderBottom: '1px solid #ddd' }}>
            <div style={{ fontSize: '18px', fontWeight: '700', color: '#333' }}>Tipo: {u?.tipologia}</div>
            <div style={{ textAlign: 'right' }}>
              <div style={{ fontSize: '11px', color: '#888' }}>Precio Lista:</div>
              <div style={{ fontSize: '18px', fontWeight: '700', color: '#333' }}>{fmt(precio)} MXN</div>
            </div>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '3px', fontSize: '10px', color: '#333', marginBottom: '14px' }}>
            <div>No. UNIDAD: {u?.numero}</div>
            <div>M² UNIDAD: {u?.m2_interior}</div>
            <div>NIVEL: {u?.nivel}</div>
            {Number(u?.m2_terraza) > 0 && <div>M² TERRAZA: {u.m2_terraza}</div>}
            <div>RECÁMARAS: {u?.recamaras}</div>
            {Number(u?.m2_bodega) > 0 && <div>BODEGA: {u.m2_bodega}</div>}
            <div>SUP TOTAL: {u?.m2_total} M²</div>
            <div>CAJONES: {u?.estacionamiento}</div>
            <div>PRECIO POR M²: {fmt(u?.precio_m2)}</div>
          </div>
          {detalles.length > 0 && (
            <div style={{ marginBottom: '14px' }}>
              <div style={{ fontSize: '11px', fontWeight: '700', color: '#333', marginBottom: '5px' }}>DETALLES DE LA UNIDAD:</div>
              {detalles.map((d, i) => <div key={i} style={{ fontSize: '10px', color: '#444', marginBottom: '2px' }}>{d}</div>)}
            </div>
          )}
          {promosDe(u?.estructura, u?.tipologia, u?.numero).length > 0 && (
            <div style={{ marginBottom: '14px', padding: '8px 10px', background: '#FFF8E1', border: '1px solid #F0D98A', borderRadius: '4px' }}>
              <div style={{ fontSize: '11px', fontWeight: '700', color: '#333', marginBottom: '4px' }}>
                {promosDe(u?.estructura, u?.tipologia, u?.numero).length > 1 ? 'PROMOCIONES:' : 'PROMOCIÓN:'}
              </div>
              {promosDe(u?.estructura, u?.tipologia, u?.numero).map(p => (
                <div key={p.id} style={{ marginBottom: '4px' }}>
                  <div style={{ fontSize: '10px', color: '#444', whiteSpace: 'pre-line', lineHeight: '1.5' }}>{p.texto}</div>
                  {p.vigencia_hasta && <div style={{ fontSize: '9px', color: '#888' }}>Vigente hasta el {fmtFechaPromo(p.vigencia_hasta)}</div>}
                </div>
              ))}
              <div style={{ fontSize: '9px', color: '#666', marginTop: '4px', fontStyle: 'italic' }}>*Consulta términos y condiciones</div>
            </div>
          )}
          <div style={{ marginBottom: '14px', paddingBottom: '10px', borderBottom: '1px solid #ddd' }}>
            <div style={{ fontSize: '16px', fontWeight: '700', color: '#333', marginBottom: '4px' }}>Cotización dirigida a:</div>
            <div style={{ fontSize: '11px', color: '#333', lineHeight: '1.7' }}>
              <div>NOMBRE: {contactoSeleccionado ? `${contactoSeleccionado.nombres} ${contactoSeleccionado.apellidos}` : ''}</div>
              {contactoSeleccionado?.telefono && <div>TELÉFONO: {contactoSeleccionado.telefono}</div>}
              {contactoSeleccionado?.correo && <div>EMAIL: {contactoSeleccionado.correo}</div>}
            </div>
          </div>
          {datosBancariosMostrar && (
            <div style={{ marginBottom: '14px', paddingBottom: '10px', borderBottom: '1px solid #ddd' }}>
              <div style={{ fontSize: '16px', fontWeight: '700', color: '#333', marginBottom: '4px' }}>Cuenta para depositar</div>
              <div style={{ fontSize: '10px', color: '#444', whiteSpace: 'pre-line', lineHeight: '1.6' }}>{datosBancariosMostrar}</div>
            </div>
          )}
          <div style={{ marginBottom: '14px', paddingBottom: '10px', borderBottom: '1px solid #ddd' }}>
            <div style={{ fontSize: '16px', fontWeight: '700', color: '#333', marginBottom: '4px' }}>Datos del asesor:</div>
            <div style={{ fontSize: '10px', color: '#444', lineHeight: '1.8' }}>
              <div>Nombre: {asesor.nombre}</div>
              <div>Celular: {asesor.celular}</div>
              <div>Email: {asesor.email}</div>
            </div>
          </div>
          <div style={{ fontSize: '9px', color: '#888', lineHeight: '1.5', textAlign: 'justify' }}>
            Todos los precios y áreas descritas en la presente cotización son estimados. Los valores y condiciones de esta Propuesta están sujetos a modificación sin previo aviso. Esta propuesta es valida por 24 horas apartir de la siguiente fecha: {fechaActual}
          </div>
        </div>
        <div>
          <div style={{ fontSize: '16px', fontWeight: '700', color: '#333', marginBottom: '14px', textAlign: 'center' }}>Opciones de pago</div>
          {planes.length === 0 ? (
            <div style={{ fontSize: '12px', color: '#888', textAlign: 'center', padding: '2rem' }}>No hay planes activos configurados</div>
          ) : planes.map((plan) => {
            const calc = calcularPlan(plan, precio, mesesEfectivosEntrega(u));
            return (
              <div key={plan.id} style={{ border: '1px solid #ddd', borderRadius: '6px', marginBottom: '12px', overflow: 'hidden' }}>
                <div style={{ background: '#1a1a2e', color: '#fff', padding: '8px', textAlign: 'center', fontSize: '11px', fontWeight: '700', letterSpacing: '1px' }}>
                  {plan.nombre.toUpperCase()}
                </div>
                <div style={{ padding: '10px 12px' }}>
                  {fila('Precio descuento Plan:', fmt(calc.precioConDescuento))}
                  {mostrarPrecioM2 && Number(u?.m2_total) > 0 && fila('Precio por m²:', fmt(calc.precioConDescuento / Number(u.m2_total)))}
                  {fila('Total ahorro:', fmt(calc.ahorro))}
                  {fila(`Enganche(${plan.enganche}%):`, fmt(calc.enganche))}
                  {fila(`Durante la obra(${plan.durante_obra}%):`, fmt(calc.duranteObra))}
                  {calc.mesesUsados > 0 && fila(`${calc.mesesUsados} mensualidades${calc.mesesUsados !== plan.meses_plan ? ' (ajustadas)' : ''} de:`, fmt(calc.mensualidad))}
                  {fila(`A la entrega(${calc.restoPorc}%):`, fmt(calc.entrega))}
                </div>
              </div>
            );
          })}
          {desarrollo.apartado > 0 && (
            <div style={{ fontSize: '11px', color: '#555', marginTop: '8px' }}>Apartado {fmt(desarrollo.apartado)} Pesos MXN</div>
          )}
        </div>
      </div>
    );
  };

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.85)', zIndex: 2000, overflowY: 'auto', padding: '1rem' }}
      onClick={() => setShowContactos(false)}>
      <div style={{ maxWidth: esComparacion ? '1100px' : '860px', margin: '0 auto' }} onClick={e => e.stopPropagation()}>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem', flexWrap: 'wrap', gap: '8px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
            <div style={{ position: 'relative' }}>
              <input
                value={contactoSeleccionado ? `${contactoSeleccionado.nombres} ${contactoSeleccionado.apellidos}` : buscarContacto}
                onChange={e => { setBuscarContacto(e.target.value); setContactoSeleccionado(null); setShowContactos(true); }}
                onFocus={() => setShowContactos(true)}
                placeholder='Buscar contacto...'
                style={{ padding: '10px 12px', border: 'none', borderRadius: '6px', fontSize: '14px', width: isMobile ? '100%' : '200px', boxSizing: 'border-box' }} />
              {showContactos && (
                <div style={{ position: 'absolute', top: '44px', left: 0, background: '#fff', border: '0.5px solid #ddd', borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.15)', zIndex: 100, width: '280px', maxHeight: '200px', overflowY: 'auto' }}>
                  {contactosFiltrados.length === 0 ? (
                    <div style={{ padding: '12px', fontSize: '13px', color: '#888' }}>Sin resultados</div>
                  ) : contactosFiltrados.map(c => (
                    <button key={c.id} onClick={() => { setContactoSeleccionado(c); setBuscarContacto(''); setShowContactos(false); }}
                      style={{ display: 'block', width: '100%', padding: '10px 14px', background: 'none', border: 'none', cursor: 'pointer', textAlign: 'left', borderBottom: '0.5px solid #f0f0f0' }}>
                      <div style={{ fontSize: '13px', fontWeight: '500', color: '#333' }}>{c.nombres} {c.apellidos}</div>
                      <div style={{ fontSize: '11px', color: '#888' }}>{c.correo}</div>
                    </button>
                  ))}
                </div>
              )}
            </div>
            {!isMobile && (
              <>
                <input value={asesor.nombre} readOnly
                  style={{ padding: '6px 12px', border: 'none', borderRadius: '6px', fontSize: '13px', width: '160px', background: 'rgba(255,255,255,0.85)', cursor: 'default', color: '#333' }} />
                <input value={asesor.celular} readOnly
                  style={{ padding: '6px 12px', border: 'none', borderRadius: '6px', fontSize: '13px', width: '120px', background: 'rgba(255,255,255,0.85)', cursor: 'default', color: '#333' }} />
              </>
            )}
          </div>
          <div style={{ display: 'flex', gap: '8px' }}>
            <button onClick={() => setMostrarPrecioM2(v => !v)}
              style={{ padding: isMobile ? '12px 16px' : '8px 16px', background: mostrarPrecioM2 ? '#fff' : 'rgba(255,255,255,0.15)', color: mostrarPrecioM2 ? '#333' : '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: isMobile ? '14px' : '13px' }}>
              {mostrarPrecioM2 ? '✓ Precio/m² por plan' : 'Precio/m² por plan'}
            </button>
            {/* FIX: bloqueadas hasta asignar contacto — solo cotizaciones
                con contacto se registran en Tendencias, y no tiene caso
                descargar/compartir un PDF que no se le va a mandar a nadie. */}
            <button onClick={handleDescargar} disabled={generando || compartiendo || !contactoSeleccionado}
              title={!contactoSeleccionado ? 'Asigna un contacto antes de descargar' : undefined}
              style={{ padding: isMobile ? '12px 16px' : '8px 16px', background: '#4A4A4A', color: '#fff', border: 'none', borderRadius: '8px', cursor: !contactoSeleccionado ? 'not-allowed' : 'pointer', opacity: !contactoSeleccionado ? 0.5 : 1, fontSize: isMobile ? '14px' : '13px' }}>
              {generando ? 'Generando...' : '⬇ Descargar PDF'}
            </button>
            <button onClick={handleCompartir} disabled={generando || compartiendo || !contactoSeleccionado}
              title={!contactoSeleccionado ? 'Asigna un contacto antes de compartir' : undefined}
              style={{ padding: isMobile ? '12px 16px' : '8px 16px', background: '#2E7D4F', color: '#fff', border: 'none', borderRadius: '8px', cursor: !contactoSeleccionado ? 'not-allowed' : 'pointer', opacity: !contactoSeleccionado ? 0.5 : 1, fontSize: isMobile ? '14px' : '13px' }}>
              {compartiendo ? 'Generando...' : '↗ Compartir'}
            </button>
            <button onClick={onClose}
              style={{ padding: isMobile ? '12px 16px' : '8px 16px', background: '#fff', color: '#333', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: isMobile ? '14px' : '13px' }}>
              × Cerrar
            </button>
          </div>
        </div>

        {/* Contenedor con escala para vista móvil */}
        <div
          ref={contenedorRef}
          style={{
            position: 'relative',
            transformOrigin: 'top left',
            transform: isMobile ? `scale(${escala})` : 'none',
            // FIX: ancho real de la tarjeta (no '100%' del modal) — si no,
            // el overlay de la marca de agua queda más ancho que la
            // cotización y se le sale por la orilla derecha.
            width: `${anchoDoc}px`,
            height: isMobile ? `${(esComparacion ? 816 : 1056) * escala}px` : 'auto',
            overflow: 'visible',
          }}>
          {esComparacion ? renderComparacion() : renderIndividual()}
          {/* FIX: marca de agua SOLO en pantalla, para desalentar screenshots
              que se manden a clientes — vive fuera de cotizacionRef, así que
              generarPDFBlob (que captura solo cotizacionRef) nunca la incluye.
              El PDF descargado/compartido siempre sale limpio. */}
          {contactoSeleccionado
            ? <MarcaDeAgua lineas={[asesor.nombre, fechaActual]} />
            : <MarcaDeAgua lineas={['COTIZACIÓN SIN VALIDEZ', 'CLIENTE PENDIENTE DE REGISTRO', asesor.nombre, fechaActual]} urgente />}
        </div>
      </div>
    </div>
  );
}